/* Genuine Suede — home page behaviour (product rails, reviews slider, accordion) */
(function () {
  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ---------- Product rail: colour swatches + mobile arrows ---------- */
  if (!customElements.get('gsh-rail')) {
    customElements.define(
      'gsh-rail',
      class GshRail extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-gsh-track]');
          this.prev = this.querySelector('[data-gsh-prev]');
          this.next = this.querySelector('[data-gsh-next]');
          this.addEventListener('click', this.onClick.bind(this));
          if (this.track) {
            this.update = this.update.bind(this);
            this.track.addEventListener('scroll', this.update, { passive: true });
            window.addEventListener('resize', this.update);
            this.update();
          }
        }
        disconnectedCallback() {
          window.removeEventListener('resize', this.update);
        }
        step() {
          const item = this.track.querySelector(':scope > li');
          if (!item) return this.track.clientWidth;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          return item.getBoundingClientRect().width + gap;
        }
        update() {
          if (!this.prev || !this.next) return;
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          this.prev.disabled = this.track.scrollLeft <= 2;
          this.next.disabled = this.track.scrollLeft >= max;
        }
        onClick(event) {
          const swatch = event.target.closest('.gsh-swatch');
          if (swatch) return this.pickSwatch(swatch);
          const behavior = reduceMotion() ? 'auto' : 'smooth';
          if (event.target.closest('[data-gsh-prev]')) this.track.scrollBy({ left: -this.step(), behavior });
          if (event.target.closest('[data-gsh-next]')) this.track.scrollBy({ left: this.step(), behavior });
        }
        pickSwatch(swatch) {
          const card = swatch.closest('[data-gsh-card]');
          if (!card) return;
          card.querySelectorAll('.gsh-swatch').forEach((el) => el.setAttribute('aria-pressed', el === swatch ? 'true' : 'false'));
          const link = card.querySelector('[data-gsh-link]');
          if (link && swatch.dataset.url) link.href = swatch.dataset.url;
          const price = card.querySelector('[data-gsh-price]');
          if (price && swatch.dataset.price) price.innerHTML = swatch.dataset.price;
          const img = card.querySelector('.gsh-card__media img');
          if (img && swatch.dataset.src) {
            img.removeAttribute('loading');
            if (swatch.dataset.srcset) img.srcset = swatch.dataset.srcset;
            img.src = swatch.dataset.src;
          }
        }
      }
    );
  }

  /* ---------- Reviews: drag to scroll + progress bar ---------- */
  if (!customElements.get('gsh-reviews')) {
    customElements.define(
      'gsh-reviews',
      class GshReviews extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-gsh-track]');
          this.bar = this.querySelector('[data-gsh-progress]');
          if (!this.track) return;
          this.progress = this.progress.bind(this);
          this.track.addEventListener('scroll', this.progress, { passive: true });
          window.addEventListener('resize', this.progress);
          this.progress();

          let down = false;
          let startX = 0;
          let startLeft = 0;
          let moved = false;
          this.track.addEventListener('pointerdown', (e) => {
            if (e.pointerType !== 'mouse') return;
            down = true;
            moved = false;
            startX = e.clientX;
            startLeft = this.track.scrollLeft;
          });
          window.addEventListener('pointermove', (e) => {
            if (!down) return;
            const dx = e.clientX - startX;
            if (Math.abs(dx) > 4) {
              moved = true;
              this.track.classList.add('is-dragging');
            }
            this.track.scrollLeft = startLeft - dx;
          });
          window.addEventListener('pointerup', () => {
            if (!down) return;
            down = false;
            this.track.classList.remove('is-dragging');
          });
          this.track.addEventListener(
            'click',
            (e) => {
              if (moved) {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            true
          );
          this.track.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') this.track.scrollBy({ left: 280, behavior: reduceMotion() ? 'auto' : 'smooth' });
            if (e.key === 'ArrowLeft') this.track.scrollBy({ left: -280, behavior: reduceMotion() ? 'auto' : 'smooth' });
          });
        }
        disconnectedCallback() {
          window.removeEventListener('resize', this.progress);
        }
        progress() {
          if (!this.bar) return;
          const visible = this.track.clientWidth / this.track.scrollWidth;
          const width = Math.max(0.12, Math.min(1, visible));
          const max = this.track.scrollWidth - this.track.clientWidth;
          const ratio = max > 0 ? this.track.scrollLeft / max : 0;
          this.bar.style.width = width * 100 + '%';
          this.bar.style.left = ratio * (1 - width) * 100 + '%';
        }
      }
    );
  }

  /* ---------- Accordion: keep only one item open ---------- */
  if (!customElements.get('gsh-accordion')) {
    customElements.define(
      'gsh-accordion',
      class GshAccordion extends HTMLElement {
        connectedCallback() {
          if (!this.hasAttribute('data-one-open')) return;
          this.querySelectorAll('details').forEach((item) => {
            item.addEventListener('toggle', () => {
              if (!item.open) return;
              this.querySelectorAll('details[open]').forEach((other) => {
                if (other !== item) other.open = false;
              });
            });
          });
        }
      }
    );
  }
})();
